import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { Modal, Drawer, Table,message, Button } from 'antd';
import { AutoTableContainer, TableManual } from 'kts-xui';
import { connect } from 'kts-platform-frame/redux'; 
import ReduxState from 'kts-platform-frame/redux/ReduxState';
import GroupButton from 'kts-platform-frame/display/components/GroupButton';
import PageUi from 'src/display/components/PageUi';
import withRouter from 'src/routes/withRouter';
import { create } from 'kts-scaffold-framework/utils/form';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据 */
@create()
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class Head extends UIBasic<IProps, ModulesState> {
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentDidMount() {
        ModulesAction.getEmailList();
    }
    addHandler = () => {
        ModulesAction.setEmailSetVisible(true, {});
    }
    editHandler = (record) => { 
        ModulesAction.setEmailSetVisible(true, record);
    }
    deleteHandler = (record) => {
        Modal.confirm({
            title: '确认删除?',
            getContainer: ()=>document.getElementById("email-drawer"),
            onOk: async () =>{ 
               const res: any = await ModulesAction.deleteEmail(record);
               if(res && !res.er){
                    message.success('操作成功！');
                    ModulesAction.getEmailList(1);
                }
            },
            onCancel() {
            },
        });
    }
    /**
     * 分页设置
     */
    pageSet = (page: number, pageSize: number) => {
        const pageMeta = this.modulesState.emailPageMeta;
        if (pageSize !== pageMeta.pageSize || page === 0) {
            pageMeta.pageNum = 1;
        } else {
            pageMeta.pageNum = page;
        }
        pageMeta.pageSize = pageSize;
        this.setModulesState(this.modulesState, () => {
            ModulesAction.getEmailList();
        });
    }
    render() {
        const pageMeta = this.modulesState.emailPageMeta;
        const { pageSize } = pageMeta;
        const columns = [
            {
                title: '名称',
                dataIndex: 'emailName',
                width: 180,
            },
            {
                title: '邮箱地址',
                dataIndex: 'emailUrl',
                width: 200,
            },
            {
                title: '登录密码',
                dataIndex: 'emailPwd',
                width: 120,
                render: (text) => {
                    return <div style={{display: 'flex'}}>
                        {
                            [1,2,3,4,5,6,7,8].map((v) => {
                                return <div key={v} style={{height: '4px', width: '4px', backgroundColor: '#000000', borderRadius: '2px', marginRight: '4px'}}></div>;
                            })
                        }
                    </div>;
                }
            },
            {
                title: '接收服务器地址',
                dataIndex: 'emailServiceUrl',
                width: 220,
            },
            {
                title: '操作',
                dataIndex: 'id',
                fixed: 'right' as ('right' | 'left'),
                align: 'center',
                render: (text, record) => {
                    const buttons: any = [
                        { title: <span onClick={()=> {this.editHandler(record)}}> 编辑 </span> },
                        { title: <span onClick={()=> {this.deleteHandler(record)}}> 删除 </span> }
                    ];
                    return <GroupButton buttons={buttons} buttonQuantity={2}/>;
                }
            },
        ];
        return (
            <div>
                {
                    <Drawer  
                        className={css.drawerPop} 
                        title={
                        <div>
                            <span style={{color: 'rgba(0, 0, 0, 0.85)'}}>收票邮箱列表</span>
                            <Button onClick={()=> {this.addHandler()}} shape="round" size="small" icon="plus" className={css.antdBtn}>
                                添加邮箱
                            </Button>
                            {/* <div className={css.addButton} onClick={()=> {this.addHandler()}}>添加邮箱</div> */}
                        </div>} 
                        width={800}
                        onClose={() => ModulesAction.setEmailDrawerVisible(false)}
                        visible={this.modulesState.emailDrawerVisible}
                    >
                        <div id="email-drawer" style={{ height: `calc(100vh - 160px)`}}> 
                            <AutoTableContainer style={{ flex: 1}} >
                                <TableManual 
                                    dataSource={this.modulesState.emailList}
                                    columns={columns as any}
                                    rowKey="id"
                                    scroll={{ x: 'max-content',  y: '100%'}}
                                    bordered={true}
                                    pagination={false}
                                /> 
                            </AutoTableContainer>  
                            <div className={css.pagination}>
                                {
                                    (pageMeta && pageMeta.total > 0) ?
                                    <PageUi pageSize={pageSize} data={pageMeta} onChange={this.pageSet} />:
                                    ''
                                }
                            </div>
                        </div>
                    </Drawer>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/apps/InvoiceInput/UI.EmailList.tsx